import React from 'react';
import { createRoot } from 'react-dom/client';

import Loading from './Loading';
import LoadingCounter from './LoadingCounter';

const loadingCounter = new LoadingCounter();
// There only should be one global loading instance
let loadingInstance;

let loadingRoot;

function close(div) {
  loadingRoot.unmount();

  div.parentNode && div.parentNode.removeChild(div);
}

function show() {
  if (loadingCounter.isEmpty()) {
    const div = document.createElement('div');

    document.body && document.body.appendChild(div);
    loadingRoot = createRoot(div);

    loadingRoot.render(<Loading />);

    loadingInstance = {
      close: () => {
        loadingCounter.clear();
        close(div);
      },
      counter: loadingCounter,
    };
  }

  loadingCounter.add();

  return loadingInstance;
}

function hide() {
  loadingCounter.dec();

  if (loadingCounter.isEmpty()) {
    loadingInstance.close();
  }
}

function reset() {
  loadingCounter.clear();
}

export { show, hide, reset };
